import styled from "@emotion/styled";

export const BulletSeparator = styled.span<{ spacing?: string }>`
  margin: 0 ${(p) => p.spacing ?? "0.25rem"};

  &::before {
    content: "•";
  }
`;
